import AddProductsModal from './AddProductsModal';

export default AddProductsModal;
